import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Message, Avatar, Heading, Text, Box, Container, Flex } from "samba-ui";
import UserApplications from "./UserApplications";
import {
  loadSingleUser,
  deleteUserDashboard,
  updateUserDashboard,
  addNewUserDashboards
} from "../redux/users";
import PageLoader from "./PageLoader";
import UserDashboardsList from "./UserDashboardsList";
import NotifyUsersEmailApproval from "./NotifyUsersEmailApproval";

const SingleUser = ({
  userId,
  user,
  loadSingleUser,
  deleteUserDashboard,
  updateUserDashboard,
  addNewUserDashboards
}) => {
  const [isNotifyModalOpen, setIsNotifyModalOpen] = useState(false);
  const [selectedDashboardFilters, setSelectedDashboardFilters] = useState(
    false
  );

  const updateDashboardFilters = (userDashboardId, dashboardId, filters) => {
    updateUserDashboard(userId, userDashboardId, dashboardId, filters);
  };

  const deleteDashboard = (userDashboardId, dashboardId) => {
    deleteUserDashboard(userId, userDashboardId, dashboardId);
  };

  const addNewDashboards = dashboardFilters => {
    setIsNotifyModalOpen(true);
    setSelectedDashboardFilters(dashboardFilters);
  };

  const onClickSendEmail = async ({
    notifyUser = false,
    notifyFinance = false
  }) => {
    addNewUserDashboards(
      userId,
      selectedDashboardFilters,
      notifyUser,
      notifyFinance
    );
    setSelectedDashboardFilters(null);
    setIsNotifyModalOpen(false);
  };

  useEffect(() => {
    const req = async () => {
      await loadSingleUser(userId);
    };
    req();
  }, [userId, loadSingleUser]);

  if (!user) {
    return <PageLoader />;
  }
  const { name, email, imageURL, dashboards } = user;
  return (
    <Container maxWidth={2048} minWidth={960}>
      <Flex>
        <Box width={3 / 4} pr={4}>
          <Heading fontWeight={500} color="palette.ink.normal">
            Manage User
          </Heading>
          <Flex mt={3} alignItems="center" justifyContent="space-between">
            <Flex>
              <Avatar src={imageURL} mr={2} width={40} height={40} />
              <Box>
                <Box>
                  <Text fontSize={1} color="palette.ink.normal">
                    {name}
                  </Text>
                </Box>
                <Text fontSize={1} color="palette.ink.normal">
                  {email}
                </Text>
              </Box>
            </Flex>
          </Flex>
        </Box>
      </Flex>
      {user.message ? (
        <Message mt={3} variant="success">
          {user.message}
        </Message>
      ) : null}
      {dashboards && (
        <UserDashboardsList
          dashboards={dashboards}
          updateDashboardFilters={updateDashboardFilters}
          deleteDashboard={deleteDashboard}
          addNewDashboards={addNewDashboards}
        />
      )}
      <UserApplications userId={userId} />
      <NotifyUsersEmailApproval
        isOpen={isNotifyModalOpen}
        onClose={() => setIsNotifyModalOpen(false)}
        onSubmit={onClickSendEmail}
      />
    </Container>
  );
};

const mapStateToProps = (state, props) => ({
  userId: props.match.params.id,
  user: state.users[props.match.params.id]
});

const mapDispatchToProps = dispatch => ({
  updateUser: () => {},
  deleteUserDashboard: (userId, userDashboardId, dashboardId) =>
    dispatch(deleteUserDashboard(userId, userDashboardId, dashboardId)),
  updateUserDashboard: (userId, userDashboardId, dashboardId, filters) =>
    dispatch(
      updateUserDashboard(userId, userDashboardId, dashboardId, filters)
    ),
  loadSingleUser: id => dispatch(loadSingleUser(id)),
  addNewUserDashboards: (userId, dashboardFilters, notifyUser, notifyFinance) =>
    dispatch(
      addNewUserDashboards(userId, dashboardFilters, notifyUser, notifyFinance)
    )
});

SingleUser.propTypes = {
  userId: PropTypes.string,
  user: PropTypes.object,
  loadSingleUser: PropTypes.func,
  deleteUserDashboard: PropTypes.func,
  updateUserDashboard: PropTypes.func,
  addNewUserDashboards: PropTypes.func,
  updateUserApplications: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleUser);
